"use client";

import type { OnboardingV3Session } from "./onboardingV3Types";

const SESSION_KEY = "onboarding_v3_session";

/**
 * V3 generate / plan-preview session (US1).
 *
 * Boundary with `onboardingWizardSessionStorage`:
 * - Wizard furthest-step keys track Paywall-**before** interrupt (cleared → UI3).
 * - This store is written only after **successful generate**; holds API payloads
 *   for Result, Plan Modal, and Paywall handoff (`draftId`).
 * - Cleared together with wizard session on Paywall-before interrupt recovery.
 */
const isBrowser = () => typeof window !== "undefined";

export const getOnboardingV3Session = (): OnboardingV3Session | null => {
  if (!isBrowser()) {
    return null;
  }
  const raw = sessionStorage.getItem(SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as OnboardingV3Session;
  } catch {
    return null;
  }
};

export const persistOnboardingV3Session = (
  session: OnboardingV3Session,
): void => {
  if (!isBrowser()) {
    return;
  }
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const patchOnboardingV3Session = (
  patch: Partial<OnboardingV3Session>,
): void => {
  const current = getOnboardingV3Session();
  if (!current) {
    return;
  }
  persistOnboardingV3Session({ ...current, ...patch });
};

export const clearOnboardingV3Session = (): void => {
  if (!isBrowser()) {
    return;
  }
  sessionStorage.removeItem(SESSION_KEY);
};
